export class Ajax {
    //An array of functions to be called before every ajax call if the call was made as global
    private static GlobalStartFunctions: Function[] = [];

    //An array of functions to be called after every ajax call (finally block) if the call was made as global
    private static GlobalFinallyFunctions: Function[] = [];

    //The function to execute if a response comes back from the server comes back as 401 unauthorized
    private static UnauthorizedFunction: Function = () => { };


    public static GET(url: string, successCallback: Function, errorCallback: Function, headers?: Headers, global = true): Promise<void> {
        let getHeaders = new Headers({
            'Content-Type': 'application/json;charset=UTF-8'
        });

        if (headers != null) {
            headers.forEach((value, key) => { getHeaders.append(key, value); });
        }

        return this.SendRequest(url, 'GET', null, getHeaders, successCallback, errorCallback, global);
    }

    public static POST(url: string, data: any, successCallback: Function, errorCallback: Function, headers?: Headers, global = true): Promise<void> {
        let postHeaders = new Headers({
            'Content-Type': 'application/json;charset=UTF-8'
        });

        if (headers != null) {
            headers.forEach((value, key) => { postHeaders.append(key, value); });
        }

        return this.SendRequest(url, 'POST', JSON.stringify(data), postHeaders, successCallback, errorCallback, global);
    }

    public static POST_MULTIPART(url: string, data: FormData, successCallback: Function, errorCallback: Function, headers?: Headers, global = true): Promise<void> {
        let multiPartHeaders = new Headers();

        if (headers != null) {
            headers.forEach((value, key) => { multiPartHeaders.append(key, value); });
        }

        return this.SendRequest(url, 'POST', data, multiPartHeaders, successCallback, errorCallback, global);
    }

    private static SendRequest(url: string, requestMethod: string, data: string | FormData, headersModel: Headers, successCallback: Function, errorCallback: Function, global: boolean): Promise<void> {
        let request = new Request(url, {
            method: requestMethod,
            credentials: 'same-origin',
            redirect: 'follow',
            body: data,
            headers: headersModel
        });

        if (global) {
            Ajax.ExecuteGlobalStart(data);
        }

        return fetch(request)
            .then((response) => { return Ajax.HandleFetchSuccess(response, successCallback); })
            .catch((error) => { Ajax.HandleFetchError(error, errorCallback); })
            .finally(() => { if (global) { Ajax.ExecuteGlobalFinally(); } });
    }

    private static HandleFetchSuccess(response: Response, successCallback: Function): Promise<void> {
        if (response.status == 401) { Ajax.UnauthorizedFunction(); return; }
        if (!response.ok) { throw Error("The server responded with Status " + response.status + (response.statusText != null && response.statusText.length > 0 ? (" and Status Text: " + response.statusText) : "")); }
        return response.json().then(
            (json) => {
                successCallback(json);
            }
        );
    }

    private static HandleFetchError(error: any, errorCallback: Function): void {
        if (error != null && error.status == 401) { Ajax.UnauthorizedFunction(); return; } //Check if this was a response model
        if (error != null && error.message != null) { console.log(error.message); }
        errorCallback(error);
    }

    private static ExecuteGlobalStart(data: any): any {
        for (let func of Ajax.GlobalStartFunctions) {
            func(data);
        }

        return data;
    }

    private static ExecuteGlobalFinally(): void {
        for (let func of Ajax.GlobalFinallyFunctions) {
            func();
        }
    }

    public static AddGlobalStartFunction(gsFunction: Function): void {
        Ajax.GlobalStartFunctions.push(gsFunction);
    }

    public static AddGlobalFinallyFunction(gfFunction: Function): void {
        Ajax.GlobalFinallyFunctions.push(gfFunction);
    }

    public static SetUnauthorizedFunction(uaFunction: Function): void {
        Ajax.UnauthorizedFunction = uaFunction;
    }
}

export class AjaxResponse {
    WasSuccess: boolean;
    Data: any;
    UserMessage?: string;
    AuthToken: string;
}